import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"windy-rain"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 7H5.5C4.11929 7 3 8.11929 3 9.5C3 10.8807 4.11929 12 5.5 12H11M17 8H13C11.8954 8 11 7.10457 11 6C11 4.89543 11.8954 4 13 4H16M17 12H15M11.5 20H8C6.89543 20 6 19.1046 6 18C6 16.8954 6.89543 16 8 16M12 16H13M21 7.99609H21.0039V8H21V7.99609ZM21 11.9961H21.0039V12H21V11.9961ZM17 15.9961H17.0039V16H17V15.9961Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WindyRain = Vue.extend<IconProps>({
  name: 'WindyRainIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'windy-rain',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WindyRain;
